module.exports = __webpack_public_path__ + "static/img/Inggris.8f28506.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/landmark/Inggris.png
// module id = 7Trz
// module chunks = 1